<template>
    <div class="article-cont" v-loading="articleLoading">   
        <leftNav ref="leftNav" :tabName='"2"' @refresh='refreshList'></leftNav>
        <div class="article">  
            <ul class="right-list"  >
                <li class="list" v-for="(item,index) in studyList" :key="index"> 
                    <div class="list-info">
                        <div class="info-tit">
                            <p class="tit"  >
                                <a href="javascript:;" v-html=" item.title" @click='toPage(item)'> </a>
                            </p>
                            <div class="info">
                                <div v-html="item.content"></div>
                                <!-- <p class="txt" v-for="(list,index) in item.infoList" :key="index">{{list}}</p> -->
                            </div>
                            <p class="txt " v-html="'出自：'+item.bookName"></p>
                        </div>
                    </div>
                </li>       
            </ul> 
            <el-pagination
                v-if="pageInfo.total!=0"
                @current-change="changePage" 
                :current-page="pageInfo.pageNum" 
                :page-count="pageInfo.pageTotal" 
                :page-size="pageInfo.pageSize" 
                :total="pageInfo.total"
                background
                layout="total, prev, pager, next" >
            </el-pagination>  
            <div v-else>
                <p class="no-data">暂无数据</p>
            </div>
        </div>
        <deductScore ref="deduct_score" v-if="isShowTip" :show.sync="isShowTip" :sourceType="'article'"></deductScore>
    </div>
</template>

<script>
import deductScore from './study_deduct_score.vue'
import { mapState, mapMutations } from 'vuex';
import { entryList } from '../../../io/api.js';
import leftNav from './left_nav.vue';
export default {
    components:{
        leftNav,
        deductScore
    },
    data () {
        return {
            articleLoading:false,
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
            studyList:[],
            isShowTip:false,
        }
    },
    computed: {
        ...mapState({
            searchVal: state => state.study.searchVal,
        }),
    },
    mounted(){
        this.getList();
    },
    methods: {
        ...mapMutations(['setTabNavNum']),
        // 刷新左侧列表和内容列表
        init(type){
            if(type=='refresh'){
                this.$refs.leftNav.getList();
            }
            this.pageInfo.pageNum = 1;
            this.getList();
        },
        refreshList(item){
            this.pageInfo.pageNum=1;
            this.getList(item);
        },
        getList(item){ 
            this.articleLoading=true;
            let params={
                page: this.pageInfo.pageNum,
                limit: this.pageInfo.pageSize,
                keyWord: this.searchVal, 
                faceName:item?item.facetName:'',
                faceValue:item?item.type:'',
            }
            entryList(params).then(res => {
                let {code, data,msg} = res.data;
                if(code == 0){
                    this.studyList = data.list || [];
                    this.pageInfo.pageTotal = data.totalPage || 1;
                    this.pageInfo.total = data.totalCount || 0;
                    // 更新 store 中条目的数量
                    this.setTabNavNum({ type: '2', num: data.totalCount || 0 });
                }else{
                    this.$message.error(msg||'请求失败～');
                }
                this.articleLoading=false;
            })
        },
        toPage(item){
            this.isShowTip=true; 
            this.$nextTick(()=>{ 
                this.$refs.deduct_score.get_studyCheckScoreStatus(item,this.searchVal)
            }) 
        },
        //分页排序相关
        changePage(num) { 
            this.pageInfo.pageNum = num; 
            this.getList()
        },
    }
}
</script>

<style lang="less" scoped>
    @import url('../study.less');
    .article-cont{
        display: flex;
        justify-content: space-between;
    }
</style>